import React, { ForwardedRef, forwardRef, memo, useMemo } from 'react';
import {
  Box,
  Checkbox,
  PressableIcon,
  Text,
  TextInput,
} from '@bonanza-social/moonlight';
import { RegistrationFieldProps } from '../../RegistrationField.types';
import { Trans } from '@bonanza-social/i18n';
import {
  BottomSheet,
  StackNavigationProp,
  useNavigation,
} from '@bonanza-social/navigation';

const TermsField = (
  {
    value,
    onValue,
    error,
    placeholderKey,
    placeholderNS,
  }: RegistrationFieldProps<'terms'>,
  _: ForwardedRef<TextInput>,
) => {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const termsComponents = useMemo(
    () => ({
      termsLink: (
        <Text
          variant="link-small"
          onPress={() =>
            navigation.navigate('MiscScreen', {
              path: '/terms',
              openInModal: true,
            })
          }
        />
      ),
      privacyLink: (
        <Text
          variant="link-small"
          onPress={() =>
            navigation.navigate('MiscScreen', {
              path: '/privacy',
              openInModal: true,
            })
          }
        />
      ),
    }),
    [navigation],
  );
  return (
    <Box>
      <Box flexDirection="row" alignItems="flex-start">
        <Box>
          <Checkbox
            error={!!error}
            checked={!!value}
            onChange={(checked) => onValue(checked)}
            testID="terms-checkbox"
          />
        </Box>
        <Box flex={1}>
          <Box flexDirection="row" flexWrap="wrap" marginLeft="space-200">
            <Text variant="body-s" color="darkSurfacePrimary">
              <Trans
                i18nKey={placeholderKey}
                ns={placeholderNS}
                components={termsComponents}
              />
              <PressableIcon
                name="info"
                width="space-400"
                height="space-400"
                color="iconSecondary"
                transform={'translate(20%, 25%)'}
                onPress={() =>
                  BottomSheet.open({
                    namespace: 'common',
                    type: 'Info',
                    titleNS: 'registration',
                    titleKey: 'verificationsChecksTitle',
                    data: {
                      textNS: 'registration',
                      textKey: 'verificationsChecksBodyLabel',
                    },
                  })
                }
              />
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default memo(forwardRef(TermsField));
